<template>
  <div>
    <div class="indoorSetting settingCenter">
      <div style="position:absolute; z-index: 1; top: 13em; left: 0.6em;cursor: pointer;">
        <img src="../../assets/images/filetImg.png" alt="" title="筛选" @click="screenDialog">
      </div>
      <el-row class="indoorSettingImg">
        <!--内景图-->
        <indoor-setting 
          :category-tag-id="tagSelected" 
          :space-id="currentSpaceInfo.id" 
          :screen-datas="screenDatas"
          :highlight-device-id="highlightDeviceId"
          @showDeviceDetail="showDetail"/>
      </el-row>
    </div>
    <!--筛选设备弹窗-->
    <screen-details  
      @screenDialog="screenDialog" 
      @screenData="screenData" 
      :divVisible="areaBgVisible"
      :tag-id="tagSelected" 
      :positionLeft="'50px'"
      :space-id="currentSpaceInfo.id"/>
    <!--设备详情-->
    <device-detail 
      :distribution-style="true" 
      ref="deviceDetail"></device-detail>
  </div>
</template>

<script>
import IndoorSetting from "./IndoorSetting.vue";
import DeviceDetail from "@/components/device_details/comp/DeviceDetail";
import screenDetails from "@/components/device_details/comp/screenDetails";

export default {
  name: "IndoorSettingView",
  components: {
    IndoorSetting,
    DeviceDetail,
    screenDetails,
  },
  props: [
    'currentSpaceInfo', 
    'tagSelected',     // 从父组件接收tagSelected
    'tagCode',
    'screenDatas',     // 从父组件接收screenDatas
    'highlightDeviceId' // 需要高亮显示的设备ID
  ],
  data() {
    return {
      pageUrl: 'overview',
      areaBgVisible: false,
    };
  },
  methods: {
    showDetail(deviceId) {
      this.$refs.deviceDetail.showDeviceDetails(deviceId);
    },
    closeDetail() {
      this.$refs.deviceDetail.close(false);
    },
    screenDialog() {
      this.areaBgVisible = !this.areaBgVisible;
    },
    screenData(data) {
      // 将筛选数据发送给父组件
      this.$emit('screenData', data);
    }
  }
}
</script>

<style scoped>
.indoorSetting {
  width: 100%;
  margin: 0 auto;
  display: block;
}

.indoorSettingImg {
  width: 100%;
  min-height: 100;
  height: 100%;
  text-align: center;
  overflow: hidden;
  line-height: 700px;
}

@media (max-width: 1020px) {
  .indoorSetting {
    width: 100%;
    margin: 20px 0;
  }

  .indoorSettingImg {
    height: auto;
  }
}

@media (max-width: 500px) {
  .indoorSetting {
    width: 100%;
    margin: 20px 0;
    height: auto;
  }

  .indoorSettingImg {
    height: auto;
    min-height: 20vh;
    overflow: hidden;
  }
}
</style>
